export enum ContactMode{
    Add = 'add',
    Edit = 'edit',
    View = 'view'
  }